export default __webpack_public_path__ + "static/media/Laqus.f49e3223.png";